import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import PDFLink from '../components/ui/PDFLink';
import styled from 'styled-components';
import { eventsPageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
`;

const Events = () => {
  const defaultData = {
    title: "Events",
    subtitle: "Activities and events at Tandara Lodge",
    introText: "Tandara organises a wide range of social events and activities for the amusement, entertainment and education of residents and families."
  };

  const customContent = (pageData) => (
    <>
      {/* Calendar Text Section */}
      {pageData?.calendarText && (
        <Paragraph>{pageData.calendarText}</Paragraph>
      )}

      {/* Event Calendars Section */}
      <Section>
        <SectionTitle>Event Calendars</SectionTitle>
        {pageData && pageData.eventCalendars && pageData.eventCalendars.length > 0 ? (
          <CalendarGrid>
            {pageData.eventCalendars.map((calendar, index) => (
              <PDFLink
                key={index}
                title={calendar.calendarTitle || `${calendar.month} ${calendar.year} Calendar`}
                description={`Events and activities for ${calendar.month} ${calendar.year}`}
                pdfUrl={calendar.documentUrl}
              />
            ))}
          </CalendarGrid>
        ) : (
          <CalendarGrid>
            <PDFLink
              title="January 2025 Events Calendar"
              description="Events and activities for January 2025"
              pdfUrl="/src/assets/pdfs/January_2025.pdf"
            />
            <PDFLink
              title="February 2025 Events Calendar"
              description="Events and activities for February 2025"
              pdfUrl="/src/assets/pdfs/February_2025.pdf"
            />
          </CalendarGrid>
        )}
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="eventsPage"
      query={eventsPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Events;
